export default {
  // 币种选择
  selectCurrency: "请选择币种",

  // 加载
  loading: "拼命加载中",

  // 地址转账情况
  addressTransferStatus: "地址转账情况",
  dataStatisticsCurrency: "数据统计币种：",
  transactionAmount: "交易数量",
  transactionCount: "交易次数",
  inflow: "转入",
  outflow: "转出",
  amount: "金额",
  times: "次数",

  // 空状态
  noData: "暂无数据",

  // 资金动向
  fundMovement: "资金动向情况",
  majorInflow: "主要流入",
  majorOutflow: "主要流出",
  frequentCounterparty: "频繁交易对手",

  // 提币作息规律
  withdrawalPattern: "提币作息规律",
};
